import { connect } from 'react-redux'
import { selectAccountPreferenceCustomProfileAppInstalled } from 'selectors/app'
import { selectSidebarCardIntegrations } from 'selectors/sidebar_cards'
import {
  selectCurrentCustomerId,
  selectCurrentCustomerEmail,
  selectCurrentTicketId,
} from 'selectors/tickets'
import { doFetchEmailMarketingIntegrations } from 'actions/email_marketing'
import {
  selectIsCreatingStateLoading,
  selectIsChangeUserStateLoading,
} from 'ducks/inAppCards/changeUser'

import View from './view'

const select = state => ({
  customerEmail: selectCurrentCustomerEmail(state),
  customerId: selectCurrentCustomerId(state),
  ticketId: selectCurrentTicketId(state),
  integrations: selectSidebarCardIntegrations(state),
  showCustomProfile: selectAccountPreferenceCustomProfileAppInstalled(state),
  isLoading:
    selectIsCreatingStateLoading(state) ||
    selectIsChangeUserStateLoading(state),
})

const perform = {
  loadEmailMarketingIntegrations: doFetchEmailMarketingIntegrations,
}

export default connect(select, perform)(View)
